import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GeneralPaymentService } from 'src/app/services/GeneralPayment/general-payment.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';
import { FinanceService } from 'src/app/services/Finance/finance.service';


@Component({
  selector: 'app-general-payment-cancel',
  templateUrl: './general-payment-cancel.component.html',
  styleUrls: ['./general-payment-cancel.component.css']
})
export class GeneralPaymentCancelComponent implements OnInit {




  Submitted: boolean = false;
  StudentList: any;
  CustomerList: any;
  StudentNo: string = '';
  ParentID: number = 0;
  FirstName: string = '';
  MiddleName: string = '';
  LastName: string = '';
  ReceiptNo: string = '';
  PaymentModeList: any;
  TotalPageAmount: any;
  SubmittedUpdate: boolean = false;
  HidePay: boolean = false;
  GeneralPaymentList: any;
  TotalPaidAmount: number = 0;
  AlertMesg: any;
  Bank: any;
  ParticularList: any;
  CashierList: any;
  BankList: any;
  ClassList: any;
  SubBranchList: any;


  constructor(private generalpaymentService: GeneralPaymentService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService, private lookupservice: LookupService, private financeservice: FinanceService) { }

  GeneralPaymentModel = {
    FeePaymentID: 0,
    ParticularID: 0,
    CreatedBy: 0,
    ClassID: 0,
    PaidByID: 0,
    RecType: '0',
    ParticularName: '',
    PaidAmount: 0.0,
    PaymentMode: '',
    CancelStatus: 'N',
    BankCharges: 0.0,
    Pay: '',
    PaymentDate: moment(new Date()).format('DD-MMM-YYYY'),
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    ReferenceNo: '',
    SubBranchID: 0,
    BankAccountID: 0,
    BankID: 0,
    PayAmount: 0.0,
    ChequeDate: '',
    ChequeNo: '',
    Remarks: '',
    PaymentStatus: '',
  };
  

  Clear() {
    this.GeneralPaymentModel.ParticularID = 0;
    this.GeneralPaymentModel.SubBranchID = 0;
    this.GeneralPaymentModel.PaidByID = 0;
    this.GeneralPaymentModel.BankAccountID = 0;
    this.GeneralPaymentModel.BankID = 0;
    this.GeneralPaymentModel.PaidAmount = 0;
    this.GeneralPaymentModel.PayAmount = 0;
    this.GeneralPaymentModel.BankCharges = 0;
    this.GeneralPaymentModel.ChequeDate = '';
    this.GeneralPaymentModel.ChequeNo = '';
    this.GeneralPaymentModel.PaymentMode = '';
    this.GeneralPaymentModel.Remarks = '';
    this.StudentList = [];
    this.StudentNo = '';
    this.ParentID = 0;
    this.FirstName = '';
    this.MiddleName = '';
    this.LastName = '';
    this.ReceiptNo = '';
    this.Submitted = false;
    this.GeneralPaymentModel.Pay = '';

  };

  GetAllGeneralPayment() {
    this.GeneralPaymentModel.PaidByID = 0;
    this.spinnerService.show();

    this.GeneralPaymentModel.FromDate =this.GeneralPaymentModel.FromDate!=null?moment(this.GeneralPaymentModel.FromDate).format('DD-MMM-YYYY'):'';
    this.GeneralPaymentModel.ToDate =this.GeneralPaymentModel.ToDate!=null?moment(this.GeneralPaymentModel.ToDate).format('DD-MMM-YYYY'):'';
   
    this.generalpaymentService.GetAllGeneralPayment(JSON.stringify(this.GeneralPaymentModel)).subscribe((data: any) => {
      this.GeneralPaymentList = data.GeneralPaymentList;
      var TotalPaidAmount = 0;
      for (var i = 0; i < this.GeneralPaymentList.length; i++) {
        TotalPaidAmount = TotalPaidAmount + this.GeneralPaymentList[i].PaidAmount;
      }
      this.TotalPaidAmount = TotalPaidAmount;
      this.spinnerService.hide();
     

    });

  };

  // PrintFeeReceipt = function (ReceiptNo, PrintType, CopyType) {

  //     var url = "../../../../App/GeneralPayment/GeneralPaymentPrint/GeneralPaymentPrint.html?PrintType=GeneralPaymentReceipt&ReceiptNo=" + ReceiptNo + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
  //     OpenPopUpWindow(url, "yes", "950", "1000");
  // };





  CancelModel = {
    FeePaymentID: 0,
    ReceiptNo: '',
    CancelRemarks: '',
  }

  ClearCancel() {
    this.CancelModel.FeePaymentID = 0;
    this.CancelModel.ReceiptNo = '';
    this.CancelModel.CancelRemarks = '';
  }

  GetReceiptNo(item) {
    this.CancelModel.ReceiptNo = item.ReceiptNo;
    this.CancelModel.FeePaymentID = item.FeePaymentID;
  }


  SaveCancelReceipt() {
    this.spinnerService.show();
    this.generalpaymentService.SaveCancelReceipt(JSON.stringify(this.CancelModel)).subscribe((data: any) => {
      this.spinnerService.show();
      this.globalHelper.CheckActionStatus(data);
      this.GetAllGeneralPayment();
    });
  }




  // Download

  PaymentListDownload() {
    this.spinnerService.show();
    if (this.GeneralPaymentList != null) {
      this.JSONToCsvConverterList(this.GeneralPaymentList, 'General_Payment_List', true);
    }

    this.spinnerService.hide();

  };

  JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
      var row = "";
      row += 'Sr. No.' + ',';
      row += 'Receipt No' + ',';
      row += 'Reference No' + ',';
      row += 'Payer Name' + ',';
      if (this.GeneralPaymentModel.RecType == 'Student') {
        row += 'Class' + ',';
      }
      row += 'Payment Mode' + ',';
      row += 'Particular' + ',';
      row += 'Bank / Bank Account' + ',';
      row += 'Transaction / Cheque No' + ',';
      row += 'Transaction Date / Cheque Date' + ',';
      row += 'Paid Amount' + ',';
      row += 'Remarks' + ',';
      row += 'Status' + ',';
      row += 'Payment Date' + ',';
      row += 'Created On' + ',';
      row += 'Created by' + ',';

      row = row.slice(0, -1);
      CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
      var sno = i + 1;
      var row = "";
      row += '"' + sno + '",';

      if (arrayData[i].ReceiptNo != null) {
        row += '"' + arrayData[i].ReceiptNo + '",';
      }
      else {
        row += '"' + '' + '",';
      }

      if (arrayData[i].ReferenceNo != null) {
        row += '"' + arrayData[i].ReferenceNo + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].Name != null) {
        row += '"' + arrayData[i].Name + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (this.GeneralPaymentModel.RecType == 'Student') {
        if (arrayData[i].ClassName != null) {
          row += '"' + arrayData[i].ClassName + '",';
        }
        else {
          row += '"' + '' + '",';
        }
      }
      if (arrayData[i].PaymentMode != null) {
        row += '"' + arrayData[i].PaymentMode + '",';
      }
      else {
        row += '"' + 'Pending' + '",';
      }
      if (arrayData[i].ParticularName != null) {
        row += '"' + arrayData[i].ParticularName + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].BankName != null) {
        row += '"' + arrayData[i].BankName + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].ChequeNo != null) {
        row += '"' + arrayData[i].ChequeNo + '",';
      }
      else {
        row += '"' + '' + '",';
      }

      if (arrayData[i].ChequeDate != null) {
        row += '"' + moment(arrayData[i].ChequeDate).format('DD-MMM-YYYY') + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].PaidAmount != null) {
        row += '"' + this.globalHelper.Decimal(arrayData[i].PaidAmount) + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].CancelStatus == 'Yes') {
        row += '"' + arrayData[i].CancelRemarks + '",';
      }
      else {
        row += '"' + arrayData[i].Remarks + '",';
      }
      if (arrayData[i].CancelStatus == 'Yes') {
        row += '"' + 'Cancelled' + '",';
      }
      else if (arrayData[i].PaymentStatus == 'Y') {
        row += '"' + 'Paid' + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].PaymentDate != null) {
        row += '"' + moment(arrayData[i].PaymentDate).format('DD-MMM-YYYY') + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].CreatedOn != null) {
        row += '"' + moment(arrayData[i].CreatedOn).format('DD-MMM-YYYY') + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].CreatedBy != null) {
        row += '"' + arrayData[i].CreatedBy + '",';
      }
      else {
        row += '"' + '' + '",';
      }


      row.slice(0, row.length - 1);
      CSV += row + '\r\n';
    }
    if (CSV == '') {
      alert('Invalid Data');
      return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');
    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
  }

  // Init and Lookup

  ngOnInit() {
    this.GetCashier();
    this.GetCustomer();
    this.GetPaymentMode();
    this.BindBank();
    this.BindBankBranch();
    this.BindParticular();
    this.GetAllGeneralPayment();
    this.BindClass();
    this.GetAllSubBranch();
  }




  GetCustomer() {

    this.lookupservice.GetLookupsList('Customer', '').subscribe((data: any) => {
      this.CustomerList = data.LookupItems;
    });
  }


  GetCashier() {
    this.lookupservice.GetLookupsList('Cashier', '').subscribe((data: any) => {
      this.CashierList = data.LookupItems;
    });
  };

  BindBank() {
    this.lookupservice.GetLookupsList('BankName', '').subscribe((data: any) => {
      this.BankList = data.LookupItems;
    });
  };

  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetAllSubBranch() {
    this.lookupservice.GetLookupsList('SubBranch', '').subscribe((data: any) => {
      this.SubBranchList = data.LookupItems;
    });
  };

  BindParticular() {
    this.lookupservice.GetLookupsList('Particular', '').subscribe((data: any) => {
      this.ParticularList = data.LookupItems;
    });
  };

  BindBankBranch() {
    this.lookupservice.GetLookupsList('Bank', '').subscribe((data: any) => {
      this.Bank = data.LookupItems;

    });
  };

  GetPaymentMode() {
    this.lookupservice.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
      this.PaymentModeList = data.LookupItems;
    });
  };


}



